import './dashboard.css'
import { ActiveStrategies, MetricHighlights, TopHeaders } from './components'
import Leaderboard from './components/Leaderboard'
import ReferralCard from './components/ReferralCard'
import { Footer } from '../../components'
import PortfolioGrowthChart from './components/PortfolioGrowthChart'
import { useAccount } from 'wagmi'

export const Dashboard = () => {
	return (
		<div>
			<div className="page-dashboard">
				<TopHeaders />

				<MetricHighlights />

				<div style={{ height: '2rem' }} />

				<PortfolioGrowthChart />

				<div style={{ height: 64 }} />

				<ActiveStrategies />
			</div>

			<div style={{ padding: '4rem 15%' }}>
				<Leaderboard />
			</div>

			<div style={{ padding: '4rem 15%', background: 'rgb(12,14,18)' }}>
				<ReferralCard />
			</div>

			<Footer />
		</div>
	)
}
